module.exports = __webpack_public_path__ + "static/media/cstar_fill.45dd5470.png";